<template>
	<div>
		<div class="modal fade" id="mdconsultarpedidos">
			<div class="modal-dialog modal-xl modal-dialog-centered">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-search"></i> Consulta de pedidos para importação</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
                            <div class="col-sm-12 col-md-8 col-lg-8">
                                <span class="lblselect2">Fornecedor:</span>
                                <select id="cbfornecedorpesqcmp" data-placeholder="Selecione um fornecedor" data-allow-clear="true"
                                        style="width:100%;" v-model="pidfornecedor">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbfiltroperiodo">Tipo:</label>
								<select class="form-control form-control-sm" v-model="vtppesqu" id="cbfiltroperiodo" @change="mtdlimpar_listagem()">
									<option value="0">Sistema</option>
									<option value="1">Fornecedor</option>
								</select>
							</div>                           
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="edidpedidopesq">Nr. Pedido:</label>
                                <input id="edidpedidopesq" type="text" v-mask="'###############'" class="form-control form-control-sm" v-model="pid" @keydown="mtdlimpar_listagem()">
                            </div>                                                       
							<div class="col-sm-12 col-md-1 col-lg-1">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo" @change="mtdlimpar_listagem()">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-1 col-lg-1">
								<label for="cbfiltropor">Por:</label>
								<select class="form-control form-control-sm" id="cbfiltropor" v-model="pfiltropor" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()">
									<option value="0">Emissão</option>
									<option value="1">Entrega</option>
								</select>
							</div>                            
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>                                                        
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbsituacaopesq">Situação:</label>
                                <select name="cbsituacaopesq" class="form-control form-control-sm" id="cbsituacaopesq" v-model="psituacao" @change="mtdlimpar_listagem()">
									<option value="0">Em digitação</option>
									<option value="1">Aguardando</option>
                                    <option value="2">Entregue</option>
                                    <option value="3">Cancelado</option>
                                    <option value="4">Todas</option>
                                </select>
                            </div>                                                        
                            <div class="col-6 col-sm-6 col-md-1 col-lg-1">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-1 col-lg-1">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i></button>
                            </div>
                            <div id="dvlistagempedidos" class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflstpedidos"
                                        :rows="lstpedidos"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.id, 8) }}
                                    </template>
                                    <template slot="slot_totalpedido" slot-scope="item">
                                        <strong style="color: #545b62;">{{ mtdformatavalordecimal(item.row.totalpedido, 2) }}</strong>
                                    </template> 
                                    <template slot="slot_entregue" slot-scope="item">
                                        <strong style="color: #65a56c;">{{ mtdformatavalordecimal(item.row.totentregue, 2) }}</strong>
                                    </template> 
                                    <template slot="slot_restante" slot-scope="item">
                                        <strong style="color: #6585a5;">{{ mtdformatavalordecimal(item.row.totrestante, 2) }}</strong>
                                    </template> 
                                    <template slot="slot_notafor" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdvernotasfor(item.row)"><i class="fa fa-info-circle"></i></button>
                                    </template>    
                                    <template slot="slot_situacao" slot-scope="item">
                                        <span v-if="parseInt(item.row.situacao) === 0"      class="badge badge-pill badge-primary bdg-digitacao" style="">Em digitação</span>
                                        <span v-else-if="parseInt(item.row.situacao) === 1" class="badge badge-pill badge-primary bdg-aguardando">Aguardando</span>
                                        <span v-else-if="parseInt(item.row.situacao) === 2" class="badge badge-pill badge-primary bdg-entregue">Entregue</span>
                                        <span v-else-if="parseInt(item.row.situacao) === 3" class="badge badge-pill badge-primary bdg-cancelado">Cancelado</span>
                                    </template>                                                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdretornoconsulta(item.row.id)" style="width: 35px;">
											<i class="fa fa-hand-o-up"></i>
										</button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-4">
                                <v-pagination style="padding: 5px 10px 5px 10px;" class="border rounded"
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>            
                            </div>    
                            <div class="col-md-8">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstpedidos.length}}</span>
                                    </li>
                                </ul>
                            </div>                            
						</div>
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>        
	</div>
</template>
<script>
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
	import util from '../utilitarios/util.js'
	export default {
        name : "cmpconsultarpedidos",
        props:[
            'idfilial'
        ],
        components:{
            VueBootstrap4Table,
            vPagination
        },			
		data: function () {
			return {
				lstpedidos   		: [],
				pid    		        : '',
				pidfornecedor       : null,
                vtppesqu            : 0,
                pfiltropor          : 0,
				pfiltroperiodo      : 1,
                psituacao           : 4,   
				pdtini       		: util.DataAtual(true),
				pdtfim       		: util.DataAtual(true),				
                pqtdregistros		: 10,
                pqtd_paginas 		: 1,
                pagina_atual 		: 1,
                pqtd_total_registros: 0,

                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },                                
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
				},
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-compra",
                        sort: false
                    },
                    {
                        label: "Nr. pedido",
                        name: "id",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',                        
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Filial",
                        name: "fantasiafilial",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Fornecedor",
                        name: "fantasia",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Emissão",
                        name: "dtemissao",
                        sort: true,
                        slot_name: "slot_dtemissao",
                        row_classes: "def-col-dtemissao",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Entrega",
                        name: "dtentrega",
                        sort: true,
                        slot_name: "slot_dtentrega",
                        row_classes: "def-col-dtentrega",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Total",
                        name: "totalpedido",
                        sort: true,
                        slot_name: "slot_totalpedido",
                        row_classes: "def-col-totalpedido",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Entregue",
                        sort: true,
                        slot_name: "slot_entregue",
                        row_classes: "def-col-totalpedido",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Restante",
                        sort: true,
                        slot_name: "slot_restante",
                        row_classes: "def-col-totalpedido",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Nr. Ped for",
                        name: "nrpedidofor",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',                        
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Nf. for",
                        name: "idnotafor",
                        sort: true,
                        slot_name: "slot_notafor",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',                        
                        row_classes: "nrfor",
                    },
                    {
                        label: "Situação",
                        name: "situacao",
                        sort: true,
                        slot_name: "slot_situacao",
                        row_classes: "def-col-situacao",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left"
                    }        
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
				}    
            }
        },
		methods: {
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},            
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},            
			mtdiniciar_def(){
				let vself = this;
				$('#mdconsultarpedidos').on('show.bs.modal', function (e) {
                    vself.lstpedidos           = [];
                    vself.pid    		      = '';
                    vself.pidfornecedor        = null;
                    vself.vtppesqu             = 0;
                    vself.pfiltropor           = 0;
                    vself.pfiltroperiodo       = 1;
                    vself.psituacao            = 4;   
                    vself.pdtini       		  = util.DataAtual(true);
                    vself.pdtfim       		  = util.DataAtual(true);				
                    vself.pqtdregistros		  = 10;
                    vself.pqtd_paginas 		  = 1;
                    vself.pagina_atual 		  = 1;
                    vself.pqtd_total_registros = 0;
				});				
				$('#mdconsultarpedidos').on('shown.bs.modal', function (e) {
					$('#edidpedidopesq').focus();
				});
				$('#mdconsultarpedidos').on('hidden.bs.modal', function (e) {
					vself.mtdfecharconsulta();
                });
                $("#cbfornecedorpesqcmp").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfornecedores',
								c1: 'id',
								c2: 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidfornecedor = $("#cbfornecedorpesqcmp").val();
                    vself.mtdlimpar_listagem();
                });           
			},            
			mtdretornoconsulta(idpedidoret){
				let payload = {
					idpedido    : idpedidoret			
				};
				this.$store.commit('PEDIDOCOMPRA_RETORNO_CHANGE',payload);					
				this.mtdfecharconsulta();
			},            
			mtdfecharconsulta(){
				let payload = {
					abrirtela    : false			
				};
				this.$store.commit('CONSULTA_PEDIDOCOMPRA_CHANGE',payload);								
            },
            mtdlimpar_listagem() {
                this.lstpedidos = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },            
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (this.pid !== ''){
                    if(parseInt(this.vtppesqu)===1){
                        rfiltro = ' and pc.nrpedidofor= "'+this.pid+'"';
                    }else{
                        rfiltro = ' and pc.id='+this.pid;
                    }
                 
                }                                
                if (this.pidfilial !== null){
                    rfiltro = rfiltro +' and pc.idfilial='+this.idfilial;
                }                
                if (this.pidfornecedor !== null){
                    rfiltro = rfiltro +' and pc.idfornecedor='+this.pidfornecedor;
                }
				if(parseInt(this.pfiltroperiodo) === 1){
                    if (parseInt(this.pfiltropor) === 0){
					    rfiltro = rfiltro + ' and pc.dtemissao between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
                    }else{
                        rfiltro = rfiltro + ' and pc.dtentrega between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';                        
                    }
				}                
                return rfiltro;
            },
            mtdexecutapesquisa(){
				let vself           = this;				
				let filtro          = vself.mtdfiltropesquisa();
				this.pagina_atual   = 1;
				let parametros      = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor  : 'qtdregistros'},
					{parametro: 'filtro',       valor  : filtro}
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
				retorno.then(function (response) {
					vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
					let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
					vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
					vself.mtdcarregapedidos(1);
				}).catch(function (response) {
					alert('Erro ao consultar registros');
				});				
            },                                    
            mtdcarregapedidos(ipagina){
                if (util.verificasessao(this)){
                    var vself       = this;
                    let loader      = this.$loading.show();
                    let filtro      = vself.mtdfiltropesquisa();
                    let parametros  = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : vself.pqtdregistros},
                        {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)}
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
                    retorno.then(function (response) {
						vself.lstpedidos = response.data.pedidoscompra;
						loader.hide();											
                    }).catch(function (response) {
                        vself.lstpedidos = [];
                        loader.hide();
                    });
                }
            }
        },
        mounted: function () { 
            this.mtdiniciar_def();      
        },
        computed: {
            abrirtela(){
                return this.$store.state.consultapedidoscompra.abrirtela;                
            },
			selecionaperiodo: function () {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
			}            						
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregapedidos(val);
			},            
			abrirtela(val){
				if (val){
					$('#mdconsultarpedidos').modal('show');
				}else{					
					$('#mdconsultarpedidos').modal('hide');
				}
			},
            pagina_atualcp(val){
                this.mtdcarregapedidos(val);
            }			
        }            
    }
</script>
<style>
</style>    